import { useEffect } from 'react';

// This allows us to lazyload images by adding the "lazyload" CSS class to an <img>, <div>, or other HTML elements.
// See their docs for usage info: https://github.com/aFarkas/lazysizes
import 'lazysizes';

const handleLazy = (e: any) => {
    const bg = e?.target?.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
};

const initializeLazySizes = () =>
    document.addEventListener('lazybeforeunveil', handleLazy, false);

const unmountLazySizes = () => {
    document.removeEventListener('lazybeforeunveil', handleLazy, false);
};

export const useLazyImages = (isLazyImage = false) => {
    useEffect(() => {
        if (isLazyImage) {
            initializeLazySizes();
        }

        return () => unmountLazySizes();
    }, [isLazyImage]);
};
